// src/icons/ArrowDown.tsx
import { jsx } from "@emotion/react/jsx-runtime";
function ArrowDown({
  strokeWidth = "1.5",
  strokeLinecap = "round",
  strokeLinejoin = "round"
}) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      width: "100%",
      viewBox: "0 0 17 14",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ jsx(
        "path",
        {
          d: "M1 9.52123L3.88111 12.4023M3.88111 12.4023L6.76222 9.52123M3.88111 12.4023L3.88111 0.8779M9.73778 9.52123",
          stroke: "currentColor",
          strokeWidth,
          strokeLinecap,
          strokeLinejoin
        }
      )
    }
  );
}

export {
  ArrowDown
};
